import React, { useEffect, useState } from "react";
import {
    makeStyles,
    createStyles,
    Theme,
    InputAdornment,
    InputBase,
    TextField,
    withStyles,
    Switch,
} from "@material-ui/core";
import { EventType } from "pages/statuses/EventType";
import { DateUtil } from "utilities/DateUtil";
import { Wastes } from "api/entities/Wastes";
import { LiquidWasteBookingDetail } from "pages/statuses/LiquidWasteBookingDetail";
import { DepositBookingDetail } from "pages/statuses/DepositBookingDetail";
import { SolidWasteBookingDetail } from "pages/statuses/SolidWasteBookingDetail";
import { BookableSolventApi } from "api/BookableWasteApi";
import { BOOKING_TYPE_ID_DEPOSIT, LIQUID_WASTES_ID_MERCURY } from "utilities/DbValueConstants";
import { FormDisplayContentsApi } from "api/FormDisplayContentsApi";
import { FormDisplayContents } from "pages/statuses/FormDisplayContents";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        form: {
            width: `800px`,
            minWidth: `600px`,
            border: "solid 2px #000000",
            margin: theme.spacing(5, `auto`),
            padding: `15px`,
            fontFamily: "メイリオ",
            fontSize: "12px",
            color: "#000000",
            "& table": {
                width: `100%`,
            },
            "& th": {
                border: "solid 1px #000000",
                textAlign: `center`,
            },
            "& td": {
                border: "solid 1px #000000",
                padding: `1px 4px`,
            },
            "& .user_info": {
                "& td": {
                    padding: `2px`,
                },
                "& .label": {
                    position: `relative`,
                    // left: `5%`,
                    display: `flex`,
                    justifyContent: `center`
                },
                "& .label_1": {
                    position: `relative`,
                    left: `5%`,
                },
                "& .label_2": {
                    position: `relative`,
                    left: `20%`,
                },
                "& .label_3": {
                    position: `relative`,
                    left: `40%`,
                },
            },
            "& .type_header": {
                width: `20%`,
                letterSpacing: `10px`,
            },
            "& .container_header": {
                width: `10%`,
            },
            "& .deposit_header": {
                letterSpacing: `10px`,
                width: `14%`,
            },
            "& .liquid_name": {
                fontSize: `14px`,
                whiteSpace: `nowrap`,
                textAlign: `center`,
                fontWeight: `bold`,
            },
            "& .liquid_sub_name": {
                fontSize: `8px`,
            },
            "& .liquid_sub_name2": {
                fontSize: `8px`,
                whiteSpace: `nowrap`,
            },
            "& .liquid_category": {
                fontSize: `8px`,
                whiteSpace: `nowrap`,
                textAlign: `center`,
                fontWeight: `bold`,
            },
            "& .liquid_input": {
                textAlign: `right`,
                "& .MuiInputBase-input": {
                    textAlign: `right`,
                },
            },
            "& .liquid_input.noBringin": {
                textAlign: `left`,
                fontSize: `11px`,
            },
            "& .deposit_label": {
                width: `4%`,
                fontSize: `8px`,
                verticalAlign: `top`,
                borderRight: `0px`,
                whiteSpace: `nowrap`,
            },
            "& .deposit_input": {
                width: `10%`,
                borderLeft: `0px`,
                verticalAlign: `top`,
                "& .MuiInputBase-input": {
                    textAlign: `right`,
                },
            },
            "& .noBringin": {
                backgroundColor: `#cccccc`,
                verticalAlign: `middle`,
            },
            "& .solid_name": {
                fontSize: `14px`,
                textAlign: `center`,
                whiteSpace: `nowrap`,
                fontWeight: `bold`,
            },
            "& .solid_sub_name": {
                fontSize: `8px`,
                textAlign: `center`,
                fontWeight: `bold`,
            },
            "& .solid_type": {
                width: `10%`,
                textAlign: `center`,
                whiteSpace: `nowrap`,
                "& span": {
                    margin: `0 auto`,
                    display: `flex`,
                },
                "& .item_left": {
                    marginRight: `3px`,
                },
                "& .item_right": {
                    marginLeft: `3px`,
                },
                "& .selected": {
                    padding: `3px`,
                    border: `solid 1px #000000`,
                    borderRadius: `50%`,
                },
                "& .non_selected": {
                    padding: `4px`,
                },
            },
            "& .solid_input": {
                width: `24%`,
                textAlign: `center`,
                whiteSpace: `nowrap`,
                "& .MuiTextField-root": {
                    width: `50%`,
                },
                "&> .MuiInputBase-root": {
                    width: `50%`,
                },
                "& .MuiTypography-root": {
                    color: "#000000",
                },
                "& .MuiInputBase-input": {
                    textAlign: `right`,
                },
            },
            "& .solid_option": {
                width: `20%`,
            },
        },
        title: {
            fontSize: `20px`,
            fontWeight: `bold`,
            textAlign: `center`,
            letterSpacing: `15px`,
            marginBottom: `-7px`,
        },
    })
);

interface Props {
    // 予約情報
    booking: EventType;
    // 表示モード
    mode: `edit` | `confirm`;
    // ローディング状態のセッター
    setLoading: any;
}

/**
 * 回収依頼票コンポーネント
 * @param props
 */
export const CollectionRequestForm: React.FC<Props> = (props) => {
    const { booking, mode, setLoading } = props;
    const classes = useStyles();
    const isDepositMode = booking.bookingTypeId === BOOKING_TYPE_ID_DEPOSIT;

    const AntSwitch = withStyles((theme: Theme) =>
        createStyles({
            root: {
                width: 28,
                height: 16,
                padding: 0,
                display: `flex`,
            },
            switchBase: {
                padding: 2,
                color: theme.palette.common.white,
                "&$checked": {
                    transform: `translateX(12px)`,
                    color: theme.palette.common.white,
                    "& + $track": {
                        opacity: 1,
                        backgroundColor: theme.palette.primary.main,
                        borderColor: theme.palette.primary.main,
                    },
                },
            },
            thumb: {
                width: 12,
                height: 12,
                boxShadow: `none`,
            },
            track: {
                border: `1px solid ${theme.palette.secondary.main}`,
                borderRadius: 16 / 2,
                opacity: 1,
                backgroundColor: theme.palette.secondary.main,
            },
            checked: {},
        })
    )(Switch);

    const initialLiquidWasteBookingDetail: LiquidWasteBookingDetail = {
        liquidWastesId: 0,
        numberOfContainer1: 0,
        numberOfContainer2: 0,
        numberOfContainer3: 0,
        numberOfContainer4: 0,
        numberOfContainer5: 0,
    };
    const initialSolidWasteBookingDetail: SolidWasteBookingDetail = {
        solidWasteCategoryId: 0,
        isKan: true,
        numberOfSolidWastes: 0,
        capacity: 0,
    };

    const [wastes, setWastes] = useState<Wastes>({ solidWastes: [], liquidWasteCategory: [], liquidWastes: [] });
    const [formDisplayContents, setFormDisplayContents] = useState<FormDisplayContents>();
    const [liquidWasteInputs, setLiquidWasteInputs] = useState<{ [key: number]: LiquidWasteBookingDetail }>(
        booking.liquidWasteBookingDetails.reduce((acc: { [key: number]: LiquidWasteBookingDetail }, liquidWaste) => {
            acc[liquidWaste.liquidWastesId] = liquidWaste;
            return acc;
        }, {})
    );
    const [depositWasteInputs, setDepositWasteInputs] = useState<{ [key: number]: DepositBookingDetail }>(
        booking.depositBookingDetails.reduce((acc: { [key: number]: DepositBookingDetail }, depositWaste) => {
            acc[depositWaste.liquidWasteCategoryId] = depositWaste;
            return acc;
        }, {})
    );
    const [solidWasteInputs, setSolidWasteInputs] = useState<{ [key: number]: SolidWasteBookingDetail }>(
        booking.solidWasteBookingDetails.reduce((acc: { [key: number]: SolidWasteBookingDetail }, solidWaste) => {
            acc[solidWaste.solidWasteCategoryId] = solidWaste;
            return acc;
        }, {})
    );

    useEffect(() => {
        const execute = async () => {
            // ローディング開始
            setLoading(true);

            const response = await BookableSolventApi.getBookableWastes();

            if (response?.status === 200) {
                setWastes(response.data);
            }

            // プロパティファイルで定義したフォームに表示する内容を取得
            const displayResponse = await FormDisplayContentsApi.getCollectionRequestFormContents();

            if (displayResponse?.status === 200) {
                setFormDisplayContents(displayResponse.data);
            }
            // ローディング終了
            setLoading(false);
        };
        execute();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setLiquidWasteInputs(
            booking.liquidWasteBookingDetails.reduce(
                (acc: { [key: number]: LiquidWasteBookingDetail }, liquidWaste) => {
                    acc[liquidWaste.liquidWastesId] = liquidWaste;
                    return acc;
                },
                {}
            )
        );
        setDepositWasteInputs(
            booking.depositBookingDetails.reduce((acc: { [key: number]: DepositBookingDetail }, depositWaste) => {
                acc[depositWaste.liquidWasteCategoryId] = depositWaste;
                return acc;
            }, {})
        );
        setSolidWasteInputs(
            booking.solidWasteBookingDetails.reduce((acc: { [key: number]: SolidWasteBookingDetail }, solidWaste) => {
                acc[solidWaste.solidWasteCategoryId] = solidWaste;
                return acc;
            }, {})
        );
    }, [booking]);

    // 付着物カラムの結合する行情報を取得
    const depositWasteGroup: { liquidWasteId: number; rowSpan: number }[] = [];
    if (wastes.liquidWastes.length > 0) {
        let targetDepositCategory = wastes.liquidWastes[0].depositsCategory;
        let targetLiquidWasteId = wastes.liquidWastes[0].id;
        let sameGroupCount = targetDepositCategory !== null ? 0 : 1;
        depositWasteGroup.push(
            ...wastes.liquidWastes.reduce((acc: { liquidWasteId: number; rowSpan: number }[], liquidWaste) => {
                if (targetDepositCategory !== null && targetDepositCategory === liquidWaste.depositsCategory) {
                    sameGroupCount++;
                } else {
                    acc.push({ liquidWasteId: targetLiquidWasteId, rowSpan: sameGroupCount });
                    sameGroupCount = 1;
                    targetDepositCategory = liquidWaste.depositsCategory;
                    targetLiquidWasteId = liquidWaste.id;
                }
                return acc;
            }, [])
        );
        depositWasteGroup.push({ liquidWasteId: targetLiquidWasteId, rowSpan: sameGroupCount });
    }

    // 廃液サブ名カラムの結合する行情報を取得
    const liquidSubNameGroup: { liquidWasteId: number; rowSpan: number }[] = [];
    if (wastes.liquidWastes.length > 0) {
        let targetLiquidWasteSubName = wastes.liquidWastes[0].subName;
        let targetLiquidWasteId = wastes.liquidWastes[0].id;
        let sameGroupCount = targetLiquidWasteSubName !== null ? 0 : 1;
        liquidSubNameGroup.push(
            ...wastes.liquidWastes.reduce((acc: { liquidWasteId: number; rowSpan: number }[], liquidWaste) => {
                if (targetLiquidWasteSubName !== null && targetLiquidWasteSubName === liquidWaste.subName) {
                    sameGroupCount++;
                } else {
                    acc.push({ liquidWasteId: targetLiquidWasteId, rowSpan: sameGroupCount });
                    sameGroupCount = 1;
                    targetLiquidWasteSubName = liquidWaste.subName;
                    targetLiquidWasteId = liquidWaste.id;
                }
                return acc;
            }, [])
        );
        liquidSubNameGroup.push({ liquidWasteId: targetLiquidWasteId, rowSpan: sameGroupCount });
    }

    const { liquidWastes, liquidWasteCategory, solidWastes } = wastes;

    /**
     * 編集モードか
     *
     * @param mode 表示モード（編集 or 確認）
     * @returns 編集モードか
     */
    const isEditMode = (mode: `edit` | `confirm`): boolean => {
        return mode === `edit`;
    };

    /**
     * 廃液の入力欄のコンポーネントを取得
     *
     * @param flag 回収対象かどうかのフラグ
     * @param numberOfContainer 回収個数
     * @returns 表示文言
     */
    const getLiquidInputComponent = (
        mode: `edit` | `confirm`,
        flag: boolean,
        value: number,
        id: number,
        onChange?: any
    ): JSX.Element => {

        if (id === LIQUID_WASTES_ID_MERCURY) {
            // 水銀は廃薬品扱いとする
            return <>{`* 廃薬品扱い`}</>;
        }

        if (!flag) {
            return <>{`回収を行っておりません。`}</>;
        }

        if (isEditMode(mode)) {
            return <NumberInput value={value || ``} onChange={onChange} disabled={isDepositMode} />;
        } else {
            return <InputBase value={value || ``} />;
        }
    };

    /**
     * 廃液の入力欄のクラス属性を取得
     *
     * @param flag 回収対象かどうかのフラグ
     * @returns クラス名
     */
    const getLiquidInputClassName = (flag: boolean): string => {
        let className =  `liquid_input`;
        // 回収対象でない、または、編集モードで付着物のみの場合、グレーアウトとする
        className += !flag || (isDepositMode && isEditMode(mode)) ? ' noBringin' : '';
        return className;
    };

    return (
        <div className={`${classes.form} print_form`}>
            <div className={classes.title}>実験廃棄物回収依頼票</div>
            <table className={`user_info`}>
                <tbody>
                    <tr>
                        <td>
                            <span className={`label`}>
                                <span style={{ position: `absolute`, left: `5%`}}>廃液回収日：</span>
                                <span>{DateUtil.parseDate(booking.start, `YYYY年 MM月 DD日 (ddd)`)}</span>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span className={`label`}>
                                <span style={{ position: `absolute`, left: `5%`}}>学部・学科：</span>
                                {`${booking.subscriberFaculty} ${booking.subscriberDepartment}`}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span className={`label_1`}>室名・担当者：{booking.subscriberLaboratoryName + " 研究室"}</span>
                            <span className={`label_2`}>担当者：{booking.subscriberName}</span>
                            <span className={`label_3`}>内線：{booking.subscriberTel}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span className={`label`}>
                                <span style={{ position: `absolute`, left: `5%`}}>メールアドレス：</span>
                                {booking.subscriberMailAddress}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <br />
            <table>
                <tbody>
                    {/* 表のヘッダー部分を作成 */}
                    <tr>
                        {[
                            { data: `種類`, className: `type_header`, colSpan: 4 },
                            {
                                data: (
                                    <>
                                        20L
                                        <br />
                                        ポリ容器
                                    </>
                                ),
                                className: `container_header`,
                            },
                            {
                                data: (
                                    <>
                                        10L
                                        <br />
                                        ポリ容器
                                    </>
                                ),
                                className: `container_header`,
                            },
                            {
                                data: (
                                    <>
                                        5L
                                        <br />
                                        ポリ容器
                                    </>
                                ),
                                className: `container_header`,
                            },
                            {
                                data: (
                                    <>
                                        2L
                                        <br />
                                        ポリ容器
                                    </>
                                ),
                                className: `container_header`,
                            },
                            {
                                data: (
                                    <>
                                        1L
                                        <br />
                                        ポリ容器
                                    </>
                                ),
                                className: `container_header`,
                            },
                            { data: `付着物`, className: `deposit_header`, colSpan: 2 },
                        ].map(({ data, className = ``, colSpan = 1 }, index) => {
                            return (
                                <th key={index} className={className} colSpan={colSpan}>
                                    {data}
                                </th>
                            );
                        })}
                    </tr>
                    {/* 表のボディ部分を作成 */}
                    {liquidWastes.map((liquidWaste) => {
                        const targetLiquidDetail = booking.liquidWasteBookingDetails?.find(
                            (detail) => detail.liquidWastesId === liquidWaste.id
                        );
                        const targetDepositDetail = booking.depositBookingDetails?.find(
                            (detail) => detail.liquidWasteCategoryId === liquidWaste.liquidWasteCategoryId
                        );
                        const liquidCategoryName = liquidWasteCategory.find(
                            (category) => category.id === liquidWaste.liquidWasteCategoryId
                        )?.name;

                        // 廃液サブ名の行結合情報を取得
                        const liquidSubNameSpanIndex = liquidSubNameGroup.findIndex(
                            (liquidSubName) => liquidSubName.liquidWasteId === liquidWaste.id
                        );
                        const liquidSubNameSpan = liquidSubNameGroup[liquidSubNameSpanIndex]?.rowSpan;
                        if (liquidSubNameSpanIndex !== -1) {
                            liquidSubNameGroup.splice(liquidSubNameSpanIndex, 1);
                        }

                        // 付着物の行結合情報を取得
                        const depositWasteSpanIndex = depositWasteGroup.findIndex(
                            (depositWaste) => depositWaste.liquidWasteId === liquidWaste.id
                        );
                        const depositWasteSpan = depositWasteGroup[depositWasteSpanIndex]?.rowSpan;
                        if (depositWasteSpanIndex !== -1) {
                            depositWasteGroup.splice(depositWasteSpanIndex, 1);
                        }
                        return (
                            <tr key={liquidWaste.name}>
                                <td className={`liquid_name`}>{liquidWaste.name}</td>
                                {liquidSubNameSpan && (
                                    <td
                                        className={`liquid_sub_name`}
                                        rowSpan={liquidSubNameSpan}
                                        colSpan={liquidWaste.subName2 === null ? 2 : 1}
                                    >
                                        {liquidWaste.subName}
                                    </td>
                                )}
                                {liquidWaste.subName2 !== null && (
                                    <td className={`liquid_sub_name2`}>{liquidWaste.subName2}</td>
                                )}
                                <td className={`liquid_category`}>{liquidCategoryName || ``}</td>
                                <td className={getLiquidInputClassName(liquidWaste.container1Flag)}>
                                    {getLiquidInputComponent(
                                        mode,
                                        liquidWaste.container1Flag,
                                        liquidWasteInputs[liquidWaste.id]?.numberOfContainer1,
                                        liquidWaste.id,
                                        (inputValue: number) => {
                                            if (targetLiquidDetail !== undefined) {
                                                targetLiquidDetail.numberOfContainer1 = inputValue;
                                            } else {
                                                booking.liquidWasteBookingDetails.push({
                                                    ...initialLiquidWasteBookingDetail,
                                                    liquidWastesId: liquidWaste.id,
                                                    numberOfContainer1: inputValue,
                                                });
                                            }
                                            const newLiquidWasteInputs = {
                                                ...liquidWasteInputs,
                                                [liquidWaste.id]: {
                                                    ...liquidWasteInputs[liquidWaste.id],
                                                    liquidWastesId: liquidWaste.id,
                                                    numberOfContainer1: inputValue,
                                                },
                                            };
                                            setLiquidWasteInputs(newLiquidWasteInputs);
                                        }
                                    )}
                                </td>
                                <td className={getLiquidInputClassName(liquidWaste.container2Flag)}>
                                    {getLiquidInputComponent(
                                        mode,
                                        liquidWaste.container2Flag,
                                        liquidWasteInputs[liquidWaste.id]?.numberOfContainer2,
                                        liquidWaste.id,
                                        (inputValue: number) => {
                                            if (targetLiquidDetail !== undefined) {
                                                targetLiquidDetail.numberOfContainer2 = inputValue;
                                            } else {
                                                booking.liquidWasteBookingDetails.push({
                                                    ...initialLiquidWasteBookingDetail,
                                                    liquidWastesId: liquidWaste.id,
                                                    numberOfContainer2: inputValue,
                                                });
                                            }
                                            const newLiquidWasteInputs = {
                                                ...liquidWasteInputs,
                                                [liquidWaste.id]: {
                                                    ...liquidWasteInputs[liquidWaste.id],
                                                    liquidWastesId: liquidWaste.id,
                                                    numberOfContainer2: inputValue,
                                                },
                                            };
                                            setLiquidWasteInputs(newLiquidWasteInputs);
                                        }
                                    )}
                                </td>
                                <td className={getLiquidInputClassName(liquidWaste.container3Flag)}>
                                    {getLiquidInputComponent(
                                        mode,
                                        liquidWaste.container3Flag,
                                        liquidWasteInputs[liquidWaste.id]?.numberOfContainer3,
                                        liquidWaste.id,
                                        (inputValue: number) => {
                                            if (targetLiquidDetail !== undefined) {
                                                targetLiquidDetail.numberOfContainer3 = inputValue;
                                            } else {
                                                booking.liquidWasteBookingDetails.push({
                                                    ...initialLiquidWasteBookingDetail,
                                                    liquidWastesId: liquidWaste.id,
                                                    numberOfContainer3: inputValue,
                                                });
                                            }
                                            const newLiquidWasteInputs = {
                                                ...liquidWasteInputs,
                                                [liquidWaste.id]: {
                                                    ...liquidWasteInputs[liquidWaste.id],
                                                    liquidWastesId: liquidWaste.id,
                                                    numberOfContainer3: inputValue,
                                                },
                                            };
                                            setLiquidWasteInputs(newLiquidWasteInputs);
                                        }
                                    )}
                                </td>
                                <td className={getLiquidInputClassName(liquidWaste.container4Flag)}>
                                    {getLiquidInputComponent(
                                        mode,
                                        liquidWaste.container4Flag,
                                        liquidWasteInputs[liquidWaste.id]?.numberOfContainer4,
                                        liquidWaste.id,
                                        (inputValue: number) => {
                                            if (targetLiquidDetail !== undefined) {
                                                targetLiquidDetail.numberOfContainer4 = inputValue;
                                            } else {
                                                booking.liquidWasteBookingDetails.push({
                                                    ...initialLiquidWasteBookingDetail,
                                                    liquidWastesId: liquidWaste.id,
                                                    numberOfContainer4: inputValue,
                                                });
                                            }
                                            const newLiquidWasteInputs = {
                                                ...liquidWasteInputs,
                                                [liquidWaste.id]: {
                                                    ...liquidWasteInputs[liquidWaste.id],
                                                    liquidWastesId: liquidWaste.id,
                                                    numberOfContainer4: inputValue,
                                                },
                                            };
                                            setLiquidWasteInputs(newLiquidWasteInputs);
                                        }
                                    )}
                                </td>
                                <td className={getLiquidInputClassName(liquidWaste.container5Flag)}>
                                    {getLiquidInputComponent(
                                        mode,
                                        liquidWaste.container5Flag,
                                        liquidWasteInputs[liquidWaste.id]?.numberOfContainer5,
                                        liquidWaste.id,
                                        (inputValue: number) => {
                                            if (targetLiquidDetail !== undefined) {
                                                targetLiquidDetail.numberOfContainer5 = inputValue;
                                            } else {
                                                booking.liquidWasteBookingDetails.push({
                                                    ...initialLiquidWasteBookingDetail,
                                                    liquidWastesId: liquidWaste.id,
                                                    numberOfContainer5: inputValue,
                                                });
                                            }
                                            const newLiquidWasteInputs = {
                                                ...liquidWasteInputs,
                                                [liquidWaste.id]: {
                                                    ...liquidWasteInputs[liquidWaste.id],
                                                    liquidWastesId: liquidWaste.id,
                                                    numberOfContainer5: inputValue,
                                                },
                                            };
                                            setLiquidWasteInputs(newLiquidWasteInputs);
                                        }
                                    )}
                                </td>
                                {depositWasteSpan && (
                                    <>
                                        {liquidWaste.depositsCategory !== null && (
                                            <td className={`deposit_label`} rowSpan={depositWasteSpan}>
                                                ({liquidWaste.depositsCategory})
                                            </td>
                                        )}
                                        <td
                                            className={`deposit_input${
                                                liquidWaste.depositsCategory === null ? ` noBringin` : ``
                                            }`}
                                            rowSpan={depositWasteSpan}
                                            colSpan={liquidWaste.depositsCategory !== null ? 1 : 2}
                                        >
                                            {liquidWaste.depositsCategory === null ? (
                                                `* 廃薬品扱い`
                                            ) : isEditMode(mode) ? (
                                                <NumberInput
                                                    value={
                                                        depositWasteInputs[liquidWaste.liquidWasteCategoryId]
                                                            ?.numberOfSolidWastes || ``
                                                    }
                                                    onChange={(inputValue: number) => {
                                                        if (targetDepositDetail !== undefined) {
                                                            targetDepositDetail.numberOfSolidWastes = inputValue;
                                                        } else {
                                                            booking.depositBookingDetails.push({
                                                                liquidWasteCategoryId:
                                                                    liquidWaste.liquidWasteCategoryId,
                                                                numberOfSolidWastes: inputValue,
                                                            });
                                                        }
                                                        const newDepositWasteInputs = {
                                                            ...depositWasteInputs,
                                                            [liquidWaste.liquidWasteCategoryId]: {
                                                                liquidWasteCategoryId:
                                                                    liquidWaste.liquidWasteCategoryId,
                                                                numberOfSolidWastes: inputValue,
                                                            },
                                                        };
                                                        setDepositWasteInputs(newDepositWasteInputs);
                                                    }}
                                                    // 付着物の入力は常に可能
                                                    disabled={false}
                                                />
                                            ) : (
                                                <InputBase
                                                    value={
                                                        depositWasteInputs[liquidWaste.liquidWasteCategoryId]
                                                            ?.numberOfSolidWastes || ``
                                                    }
                                                />
                                            )}
                                        </td>
                                    </>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <br />
            <table>
                <tbody>
                    {/* 表の固形廃棄物部分を作成 */}
                    {solidWastes.map((solidWaste, index) => {
                        const targetSolidDetailIndex = booking.solidWasteBookingDetails?.findIndex(
                            (detail) => detail.solidWasteCategoryId === solidWaste.id
                        );
                        const targetSolidDetail = booking.solidWasteBookingDetails[targetSolidDetailIndex];
                        const isExitSubName = solidWaste.subName !== null;
                        return (
                            <tr key={solidWaste.name}>
                                <td className={`solid_name`} colSpan={isExitSubName ? 1 : 2}>
                                    {solidWaste.name}
                                </td>
                                {isExitSubName && <td className={`solid_sub_name noBringin`}>{solidWaste.subName}</td>}
                                <td className={`solid_type`}>
                                    <span>
                                        <span
                                            className={`item_left${
                                                !isEditMode(mode) &&
                                                !!solidWasteInputs[solidWaste.id]?.isKan &&
                                                solidWasteInputs[solidWaste.id]?.numberOfSolidWastes > 0 ||
                                                solidWasteInputs[solidWaste.id]?.capacity > 0
                                                    ? ` selected`
                                                    : ` non_selected`
                                            }`}
                                        >
                                            缶
                                        </span>
                                        {isEditMode(mode) ? (
                                            <AntSwitch
                                                name="checkedC"
                                                checked={
                                                    solidWasteInputs[solidWaste.id]?.isKan !== undefined
                                                        ? !solidWasteInputs[solidWaste.id]?.isKan
                                                        : false
                                                }
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                    if (targetSolidDetail !== undefined) {
                                                        targetSolidDetail.isKan = !e.target.checked;
                                                    } else {
                                                        booking.solidWasteBookingDetails.push({
                                                            ...initialSolidWasteBookingDetail,
                                                            solidWasteCategoryId: solidWaste.id,
                                                            isKan: !e.target.checked,
                                                        });
                                                    }
                                                    const newSolidWasteInputs = {
                                                        ...solidWasteInputs,
                                                        [solidWaste.id]: {
                                                            ...solidWasteInputs[solidWaste.id],
                                                            solidWasteCategoryId: solidWaste.id,
                                                            isKan: !e.target.checked,
                                                        },
                                                    };
                                                    setSolidWasteInputs(newSolidWasteInputs);
                                                }}
                                            />
                                        ) : (
                                            `・`
                                        )}
                                        <span
                                            className={`item_right${
                                                !isEditMode(mode) &&
                                                !solidWasteInputs[solidWaste.id]?.isKan &&
                                                solidWasteInputs[solidWaste.id]?.numberOfSolidWastes > 0 ||
                                                solidWasteInputs[solidWaste.id]?.capacity > 0
                                                    ? ` selected`
                                                    : ` non_selected`
                                            }`}
                                        >
                                            袋
                                        </span>
                                    </span>
                                </td>
                                <td className={`solid_input`}>
                                    {isEditMode(mode) ? (
                                        <>
                                            <NumberInput
                                                value={solidWasteInputs[solidWaste.id]?.numberOfSolidWastes || ``}
                                                InputProps={{
                                                    endAdornment: <InputAdornment position="end">個</InputAdornment>,
                                                }}
                                                onChange={(inputValue: number) => {
                                                    if (targetSolidDetail !== undefined) {
                                                        targetSolidDetail.numberOfSolidWastes = inputValue;
                                                    } else {
                                                        booking.solidWasteBookingDetails.push({
                                                            ...initialSolidWasteBookingDetail,
                                                            solidWasteCategoryId: solidWaste.id,
                                                            numberOfSolidWastes: inputValue,
                                                        });
                                                    }
                                                    const newSolidWasteInputs = {
                                                        ...solidWasteInputs,
                                                        [solidWaste.id]: {
                                                            ...solidWasteInputs[solidWaste.id],
                                                            solidWasteCategoryId: solidWaste.id,
                                                            numberOfSolidWastes: inputValue,
                                                        },
                                                    };
                                                    setSolidWasteInputs(newSolidWasteInputs);
                                                }}
                                                disabled={false}
                                            />
                                            <NumberInput
                                                value={solidWasteInputs[solidWaste.id]?.capacity || ``}
                                                InputProps={{
                                                    endAdornment: <InputAdornment position="end">kg</InputAdornment>,
                                                }}
                                                onChange={(inputValue: number) => {
                                                    if (targetSolidDetail !== undefined) {
                                                        targetSolidDetail.capacity = inputValue;
                                                    } else {
                                                        booking.solidWasteBookingDetails.push({
                                                            ...initialSolidWasteBookingDetail,
                                                            solidWasteCategoryId: solidWaste.id,
                                                            capacity: inputValue,
                                                        });
                                                    }
                                                    const newSolidWasteInputs = {
                                                        ...solidWasteInputs,
                                                        [solidWaste.id]: {
                                                            ...solidWasteInputs[solidWaste.id],
                                                            solidWasteCategoryId: solidWaste.id,
                                                            capacity: inputValue,
                                                        },
                                                    };
                                                    setSolidWasteInputs(newSolidWasteInputs);
                                                }}
                                                disabled={true}
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <InputBase
                                                value={solidWasteInputs[solidWaste.id]?.numberOfSolidWastes || ``}
                                                endAdornment={<InputAdornment position="end">個</InputAdornment>}
                                            />
                                            <InputBase
                                                value={solidWasteInputs[solidWaste.id]?.capacity || ``}
                                                endAdornment={<InputAdornment position="end">kg</InputAdornment>}
                                            />
                                        </>
                                    )}
                                </td>
                                {index === 0 && (
                                    <td className={`solid_option`} rowSpan={solidWastes.length}>
                                        袋は二重にし、容器に日付・研究室名・吸着物を記入してください。
                                    </td>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <div style={{ width: `30%`, position: `relative`, left: `70%` }}>環境安全センター (内線)5827</div>
            {formDisplayContents?.collectionRequestNote.map(str => {
                return <div>{str}</div>
            })}
            <div style={{ width: `15%`, position: `relative`, left: `85%`, fontSize: `8px` }}>2018年11月1日改訂</div>
        </div>
    );
};

/**
 * 数値入力用コンポーネント
 */
const NumberInput: React.FC<{ value: number | string; onChange: any; disabled: boolean; InputProps?: any }> = (
    props
) => {
    const minLimit = 0;
    const maxLimit = 999;
    return (
        <TextField
            type="number"
            value={props.value}
            InputProps={{
                inputProps: { min: minLimit, max: maxLimit },
                ...props.InputProps,
            }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const inputValue = e.target.value !== `` ? parseInt(e.target.value) : 0;
                const adjustValue = Math.min(maxLimit, Math.max(minLimit, inputValue));
                props.onChange(adjustValue);
            }}
            disabled={props.disabled}
        />
    );
};
